'use client'

import { memo } from 'react'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const VaultV2PerformanceError = () => {
  return <ErrorServiceUnavailable minHeight="395px" />
}

export default memo(VaultV2PerformanceError)
